import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    loadingState : false
}

export const loadingSlice = createSlice({
    name : "loading",
    initialState,
    reducers : {
        saveLoadingState : (state, action) =>{
            state.loadingState = action.payload;
        },
    }

})

export const {saveLoadingState} = loadingSlice.actions;
export const loader = (state) => state.loading.loadingState;